import { render, staticRenderFns } from "./cheCkimg.vue?vue&type=template&id=0c86292c&"
import script from "./cheCkimg.vue?vue&type=script&lang=js&"
export * from "./cheCkimg.vue?vue&type=script&lang=js&"
import style0 from "./cheCkimg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports